export class TransfersOmniEventType {

	static INIT = 'INIT_TRANSFER';

	static STEPS = {
		FAVORED_DATA: 'OMNI_FAVORED_DATA',
		TRANSFER_DATA: 'OMNI_TRANSFER_DATA',
		TRANSFER_CONFIRMATION:  'OMNI_TRANSFER_CONFIRMATION',
		SECURITY_CHECK:  'OMNI_SECURITY_CHECK',
		TRANSFER_RESULT:  'OMNI_TRANSFER_RESULT'
	};

	static TRANSFER = {
		SEND: 'OMNI_SEND',
		CONFIRM: 'OMNI_CONFIRM'
	};

	static MODAL = {
		TRUE_MODAL: 'TRUE_MODAL'
	};

	static ACTIONS = {
		BUTTONS: 'OMNI_TRANSFER_BUTTONS'
	};

	static ERROR = 'OMNI_ERROR';

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/transfers-omni/transfers-omni.event.type.ts